export default __webpack_public_path__ + "static/media/img-ln-7-map.fc54b9ab.png";